import React from "react";
import parseNumber from "../../../../utils/parseCalculate";
import { Box } from "@mui/material";
import WaterQualityDevice from "./Devices/WaterQualityDevice";
import { useLiveDevice } from "../../../../hooks/useLiveDeviceData";

function Item(props) {
  const { sx, ...other } = props;
  return <Box {...other} />;
}

const WaterQualityWrap = ({
  index,
  pinned,
  onPinClick,
  name,
  deviceId,
  isExpired,
}) => {
  const { data, status } = useLiveDevice(isExpired ? null : deviceId, {
    watchStatus: true,
  });
  const deviceStatus = isExpired ? "inactive" : status;

  const handlePinClick = () => {
    const newPinned = !pinned;
    onPinClick(parseInt(index), Boolean(newPinned));
    localStorage.setItem(index.toString(), newPinned.toString());
  };

  return (
    <Item>
      <WaterQualityDevice
        deviceStatus={deviceStatus}
        deviceId={deviceId}
        codValue={isExpired ? "Subscription Expired" : parseNumber(data?.cod)}
        bodValue={isExpired ? "" : parseNumber(data?.bod)}
        tssValue={isExpired ? "" : parseNumber(data?.tss)}
        phValue={isExpired ? "" : parseNumber(data?.ph)}
        tempValue={isExpired ? "" : parseNumber(data?.temp)}
        lastUpdated={
          isExpired
            ? ""
            : `
          ${
            data?.date_time
              ? new Date(data.date_time).toLocaleDateString("en-GB").slice(0, 10)
              : "--"
          } ${
            data?.date_time
              ? new Date(data.date_time).toLocaleTimeString("en-US", {
                  hour12: true,
                })
              : "--"
          }`
        }
        powerStatus={isExpired ? null : data?.battery}
        title={name}
        date={new Date().toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        })}
        isExpired={isExpired}
        onPinClick={handlePinClick}
        pinned={pinned}
        index={index}
      />
    </Item>
  );
};

export default WaterQualityWrap;
